var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"line-progress"},[_c('span',{style:(_vm.computedTotalStyle)}),_c('span',{style:(_vm.computedCurrentStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }